export default "__VITE_ASSET__CpsmmHHC__"